import { useCallback, useEffect, useState } from 'react';

import { useMap } from '@domain/map/MapContext';

import { getZoomMessage } from './helpers/getZoomMessage';

interface IProps {
  isPremium: boolean;
  initialZoom: number;
}

export const ZoomNotification = ({ isPremium, initialZoom }: IProps) => {
  const { map } = useMap();
  const [zoom, setZoom] = useState(initialZoom);
  const message = zoom && getZoomMessage({ zoomLevel: zoom, isPremium });

  const updateZoom = useCallback(() => {
    setZoom(map!.getZoom());
  }, [map]);

  useEffect(() => {
    if (map) {
      map.on('zoom', updateZoom);
    }

    return () => {
      if (map) {
        map.off('zoom', updateZoom);
      }
    };
  }, [map, updateZoom]);

  return map && message ? (
    <div
      className="body-text-xs z-mid bg-trench/80 col-start-1 col-end-1 row-start-1 row-end-1 mx-auto mt-[20px] mb-auto flex rounded-full px-3 py-1.5 whitespace-nowrap text-white md:mt-[76px]"
      data-testid="zoomNotification"
    >
      {message}
    </div>
  ) : (
    <></>
  );
};
